<template>
  <li
    v-if="items.length > 0"
    :key="`navbar_menu.${title}`"
    class="nav-item dropdown dropdown-user"
  >
    <a
      href="#"
      class="navbar-nav-link dropdown-toggle"
      data-toggle="dropdown"
      aria-expanded="false"
      @click="() => (show = !show)"
      @focusout="onFocusOut"
    >
      <span>{{ title }}</span>
    </a>

    <div :class="{ show: show }" class="dropdown-menu dropdown-menu-right">
      <template v-for="(action, index) in items">
        <div v-if="action.divider" :key="action" class="dropdown-divider"></div>
        <router-link
          v-else-if="action.route"
          :key="`route.${index}`"
          :to="action.route"
          class="dropdown-item"
          @click="action.onClick && !action.route ? action.onClick(action) : ''"
        >
          <i v-if="action.icon" :class="action.icon"></i>
          {{ action.text }}
        </router-link>
        <a
          v-else
          :key="`lint.${index}`"
          :href="action.url"
          class="dropdown-item"
          target="_blank"
          @click="action.onClick && !action.route ? action.onClick(action) : ''"
        >
          <i v-if="action.icon" :class="action.icon"></i>
          {{ action.text }}
        </a>
      </template>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      show: false,
    }
  },

  methods: {
    onFocusOut() {
      // handle action click before focus out!!!
      setTimeout(() => (this.show = false), 500)
    },
  },
}
</script>
